import { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/stores/authStore";
import { RequireAuth, RequireRole } from "@/components/auth/RequireAuth";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ShopModule from "@/modules/shop/ShopModule";
import BackofficeModule from "@/modules/backoffice/BackofficeModule";
import CrmShell from "@/modules/crm/CrmShell";
import { OfflineStreifen } from "@/modules/home/OfflineStreifen";

export default function App() {
  const init = useAuth((s) => s.init);
  const role = useAuth((s) => s.role);
  const session = useAuth((s) => s.session);

  useEffect(() => {
    init();
  }, [init]);

  return (
    <>
      {/* Über ALLEN Routen, auch über Login — siehe Kommentar in der Komponente. */}
      <OfflineStreifen />

      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/registrieren" element={<RegisterPage />} />

        <Route
          path="/shop/*"
          element={
            <RequireAuth>
              <ShopModule />
            </RequireAuth>
          }
        />

        {/* Das neue CRM: Kunden + Dienstag-Tour. Ersetzt schrittweise Backoffice+Fahrer. */}
        <Route
          path="/crm/*"
          element={
            <RequireRole roles={["admin", "buero", "dispatch", "fahrer"]}>
              <CrmShell />
            </RequireRole>
          }
        />

        {/* Das alte Fahrer-Modul ist STILLGELEGT.
          Es enthielt einen zweiten, konkurrierenden Abschluss-Pfad (useStopAction),
          der Rechnungen mit eigener — fehlerhafter — MwSt-Logik im Client erzeugte
          und nichts von der Idempotenz-Sicherung des Servers wusste. Zwei Wege,
          die dasselbe Geld buchen, sind einer zu viel. Alles läuft über /crm/tour. */}
        <Route path="/fahrer/*" element={<Navigate to="/crm/tour" replace />} />

        <Route
          path="/backoffice/*"
          element={
            <RequireRole roles={["admin", "buero", "dispatch"]}>
              <BackofficeModule />
            </RequireRole>
          }
        />

        <Route
          path="/"
          element={<Navigate to={landingFor(role, !!session)} replace />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function landingFor(role: string, hasSession: boolean): string {
  if (!hasSession) return "/login";
  switch (role) {
    // Personal landet im CRM — das ist die App, mit der der Hof arbeitet.
    case "admin":
    case "buero":
    case "dispatch":
    case "fahrer":
      return "/crm";
    default:
      return "/shop";
  }
}
